import { TaskError } from '../../errors/TaskError';
import { AbstractTask } from './AbstractTask';
import { UploaderError } from '../../errors/UploaderError';
export class LockTransfer extends AbstractTask {
    constructor(context) {
        super(context);
        this.sdkFatalErrors = [
            this.context.transferSdk.errors.LockTransferError.NotFoundError,
            this.context.transferSdk.errors.LockTransferError.UnauthorizedError,
            this.context.transferSdk.errors.LockTransferError.InvalidParameterError,
            this.context.transferSdk.errors.LockTransferError.TransferAlreadyLockedError,
            this.context.transferSdk.errors.LockTransferError.TransferIsDirtyError,
            this.context.transferSdk.errors.LockTransferError.UnknownError,
            this.context.transferSdk.errors.GetTeamTransferError.NotFoundError,
            this.context.transferSdk.errors.GetTeamTransferError.UnauthorizedError,
            this.context.transferSdk.errors.GetTeamTransferError.InvalidParameterError,
            this.context.transferSdk.errors.GetTeamTransferError.UnknownError,
            this.context.transferSdk.errors.GetTransferError.NotFoundError,
            this.context.transferSdk.errors.GetTransferError.UnauthorizedError,
            this.context.transferSdk.errors.GetTransferError.InvalidParameterError,
            this.context.transferSdk.errors.GetTransferError.UnknownError,
        ];
        this.transfer = context.transfer;
        this.lockTransferParameters = {
            transferId: this.transfer.id,
        };
    }
    isLastTask() {
        return true;
    }
    preProcess(context) {
        return this;
    }
    lockTransfer() {
        return new Promise(async (resolve, reject) => {
            try {
                const transfer = await this.context.transferSdk.lockTransfer(this.lockTransferParameters);
                resolve(transfer);
            }
            catch (error) {
                if (error instanceof this.context.transferSdk.errors.LockTransferError.TransferAlreadyLockedError) {
                    try {
                        if (this.transfer.teamId) {
                            const transfer = await this.context.transferSdk.getTeamTransfer({ transferId: this.transfer.id, teamId: this.transfer.teamId });
                            resolve(transfer);
                        }
                        else {
                            const transfer = await this.context.transferSdk.getTransfer({ transferId: this.transfer.id });
                            resolve(transfer);
                        }
                    }
                    catch (error) {
                        reject(error);
                    }
                }
                else {
                    reject(error);
                }
            }
        });
    }
    process() {
        return new Promise(async (resolve) => {
            try {
                this.response = await this.lockTransfer();
            }
            catch (error) {
                if (error instanceof this.context.transferSdk.errors.LockTransferError.TransferAlreadyLockedError ||
                    error instanceof this.context.transferSdk.errors.LockTransferError.NotFoundError ||
                    error instanceof this.context.transferSdk.errors.LockTransferError.TransferIsDirtyError ||
                    error instanceof this.context.transferSdk.errors.LockTransferError.UnauthorizedError ||
                    error instanceof this.context.transferSdk.errors.LockTransferError.InvalidParameterError ||
                    error instanceof this.context.transferSdk.errors.LockTransferError.UnknownError ||
                    error instanceof this.context.transferSdk.errors.LockTransferError.InternalServerError ||
                    error instanceof this.context.transferSdk.errors.LockTransferError.BadGatewayError ||
                    error instanceof this.context.transferSdk.errors.LockTransferError.GatewayTimeoutError ||
                    error instanceof this.context.transferSdk.errors.LockTransferError.NetworkError ||
                    error instanceof this.context.transferSdk.errors.LockTransferError.TimeoutError ||
                    error instanceof this.context.transferSdk.errors.LockTransferError.ConnectionAbortedError ||
                    error instanceof this.context.transferSdk.errors.GetTeamTransferError.NotFoundError ||
                    error instanceof this.context.transferSdk.errors.GetTeamTransferError.UnauthorizedError ||
                    error instanceof this.context.transferSdk.errors.GetTeamTransferError.InvalidParameterError ||
                    error instanceof this.context.transferSdk.errors.GetTeamTransferError.UnknownError ||
                    error instanceof this.context.transferSdk.errors.GetTeamTransferError.InternalServerError ||
                    error instanceof this.context.transferSdk.errors.GetTeamTransferError.BadGatewayError ||
                    error instanceof this.context.transferSdk.errors.GetTeamTransferError.GatewayTimeoutError ||
                    error instanceof this.context.transferSdk.errors.GetTeamTransferError.NetworkError ||
                    error instanceof this.context.transferSdk.errors.GetTeamTransferError.TimeoutError ||
                    error instanceof this.context.transferSdk.errors.GetTeamTransferError.ConnectionAbortedError ||
                    error instanceof this.context.transferSdk.errors.GetTransferError.InvalidParameterError ||
                    error instanceof this.context.transferSdk.errors.GetTransferError.UnknownError ||
                    error instanceof this.context.transferSdk.errors.GetTransferError.InternalServerError ||
                    error instanceof this.context.transferSdk.errors.GetTransferError.NotFoundError ||
                    error instanceof this.context.transferSdk.errors.GetTransferError.UnauthorizedError ||
                    error instanceof this.context.transferSdk.errors.GetTransferError.BadGatewayError ||
                    error instanceof this.context.transferSdk.errors.GetTransferError.GatewayTimeoutError ||
                    error instanceof this.context.transferSdk.errors.GetTransferError.NetworkError ||
                    error instanceof this.context.transferSdk.errors.GetTransferError.TimeoutError ||
                    error instanceof this.context.transferSdk.errors.GetTransferError.ConnectionAbortedError) {
                    this.error = new TaskError(this, error);
                }
                else {
                    this.error = new TaskError(this, error);
                }
            }
            resolve(this);
        });
    }
    postProcess(context) {
        this.transfer.populateLockedTransfer(this.response);
        return null;
    }
    processError() {
        if (this.error) {
            if (this.error.isInstanceOfOneOfTheseErrors(this.sdkFatalErrors)) {
                this.error.unrecoverableError(new UploaderError(this.error.getError()));
            }
            else if (this.error.getError() instanceof this.context.transferSdk.errors.LockTransferError.NetworkError ||
                this.error.getError() instanceof this.context.transferSdk.errors.LockTransferError.TimeoutError ||
                this.error.getError() instanceof this.context.transferSdk.errors.LockTransferError.ConnectionAbortedError) {
                this.error.setRecoveryTask(this.error.getTask());
            }
            else if (this.executionNumber < this.maxExecutionNumber) {
                this.error.setRecoveryTask(this.error.getTask());
            }
            else {
                this.error.unrecoverableError(new UploaderError(this.error.getError()));
            }
            return this.error;
        }
        throw new Error('Method task.processError() should be called only if task.isOnError() === true');
    }
}
